export default __webpack_public_path__ + "static/media/banco-bogota.bfe3919f.svg";